<template>
	<div id="ModalEditShipping" class="modal fade">
		<div class="modal-dialog modal-dialog-vertical-center modal-lg" role="document">
			<div class="modal-content bd-0 tx-14">
				<modal-loading :show="loading"></modal-loading>
				<div class="modal-header pd-y-20 pd-x-25">
					<h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{info ? $t('express.修改') : $t('express.添加')}}{{$t("express.物流渠道")}}
          </h6>
					<button type="button" data-dismiss="modal" aria-label="Close" class="close">
            <span aria-hidden="true">×</span>
          </button>
				</div>
				<div class="modal-body pd-25">
					<div class="row form-group">
						<label class="col-3 col-form-label form-control-sm text-right">
              {{$t("express.物流名称：")}}<span class=" tx-danger">*</span>
            </label>
						<div class="col-6">
							<input class=" form-control form-control-sm tx-13" type="text" v-model.trim="logistics">
						</div>
					</div>
					<div v-if="countrys.length" class="row mg-b-10">
						<div class="col-12">
							{{$t("express.支持国家：")}}<span class=" tx-danger">*</span>
						</div>
						<div class="col-12">
							<div class=" d-flex">
								<div class="continents-nav">
									<a v-for="continent in countrys" :key="continent.name" href="javascript:;" :class="{active: continent.active}" @click="changeContinent(continent)">
										<label class="ckbox mg-b-0">
                      <input
                        type="checkbox"
                        :checked="checkedContinent(continent)"
                        @change="selectAllCountry($event, continent)"
                      >
                      <span></span>
                    </label> {{continent.name}}
										<span v-if="checkedNum(continent)">
                      ({{checkedNum(continent)}})
                    </span>
									</a>
								</div>
								<div class="country-wrap">
									<ul v-for="continent in countrys" :key="continent.name" :class="{active: continent.active}" class="country-list">
										<li v-for="country in continent.sub" :key="country.code2" :class="{active: country.checked}">
											<label class="ckbox mg-b-0">
                        <input
                          type="checkbox"
                          v-model="country.checked"
                        >
                        <span>{{country.nameCN}}</span>
                      </label>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					<div class="form-group row">
						<label for="iptTargetType" class="col-3 col-form-label form-control-sm text-right">
              {{$t("express.运费规则：")}}<span class=" tx-danger">*</span>
            </label>
						<div class="col-md-9 col-sm-12">
							<div>
								<div class="form-check form-check-inline mg-r-15">
									<label class="rdiobox">
                    <input
                      type="radio"
                      name="ruleType"
                      value="1"
                      v-model="ruleType"
                    >
                    <span>{{$t("express.按单收费")}}</span>
                  </label>
								</div>
								<div class="form-check form-check-inline mg-r-15">
									<label class="rdiobox">
                    <input
                      type="radio"
                      name="ruleType"
                      value="2"
                      v-model="ruleType"
                    >
                    <span>{{$t("express.按重量收费")}}</span>
                  </label>
								</div>
								<div class="form-check form-check-inline">
									<label class="rdiobox">
                    <input
                      type="radio"
                      name="ruleType"
                      value="3"
                      v-model="ruleType"
                    >
                    <span>{{$t("express.按件收费")}}</span>
                  </label>
								</div>
							</div>
							<div v-if="ruleType == 1">
								<span class="tx-gray-600 mg-r-5">{{$t("express.每单")}}</span>
								<input type="text" class=" d-inline-block form-control form-control-sm tx-13 wd-60 mg-r-5" v-model="everyFee" />
								<span class="tx-gray-600">{{$t("express.元")}}</span>
							</div>
							<div v-if="ruleType == 2">
								<p>
									<span class="tx-gray-600 mg-r-5">{{$t("express.首重")}}</span>
									<input type="text" class="d-inline-block wd-60 mg-r-5 form-control form-control-sm tx-13 " v-model="startWeight" />
									<span class="tx-gray-600">{{$t("express.克")}}</span>，
									<span class="tx-gray-600 mg-r-5">{{$t("express.运费")}}</span>
									<input type="text" class="d-inline-block wd-60 mg-r-5 form-control form-control-sm tx-13" v-model="startPrice" />
									<span class="tx-gray-600">{{$t("express.元")}}</span>，
								</p>
								<p>
									<span class="tx-gray-600 mg-r-5">{{$t("express.续重每")}}</span>
									<input type="text" class="d-inline-block wd-60 mg-r-5 form-control form-control-sm tx-13" v-model="incWeight" />
									<span class="tx-gray-600">{{$t("express.克")}}</span>，
									<span class="tx-gray-600 mg-r-5">{{$t("express.运费增加")}}</span>
									<input type="text" class="d-inline-block wd-60 mg-r-5 form-control form-control-sm tx-13" v-model="incPrice" />
									<span class="tx-gray-600">{{$t("express.元")}}</span>，
								</p>
							</div>
							<div v-if="ruleType == 3">
								<p>
									<span class="tx-gray-600">{{$t("express.首件")}}</span>
									<input type="text" class="d-inline-block wd-60 form-control form-control-sm mg-x-5" v-model.number="startPrice3" />
									<span class="tx-gray-600">{{$t("express.元")}}</span>
								</p>
								<p>
									<span class="tx-gray-600">{{$t("express.后续每件")}}</span>
									<input type="text" class="d-inline-block wd-60 form-control form-control-sm mg-x-5" v-model.number="incPrice3" />
									<span class="tx-gray-600">{{$t("express.元")}}</span>
								</p>
							</div>
						</div>
					</div>

					<div class="row form-group">
						<label class="col-3 col-form-label form-control-sm text-right">
              {{$t("express.体积重计算系数：")}}
            </label>
						<div class="col-4">
							<input class=" form-control form-control-sm tx-13" type="text" v-model.trim="volumetricWeight">
						</div>
					</div>

					<div class="row form-group">
						<label class="col-3 col-form-label form-control-sm text-right">
              {{$t("express.是否启用：")}}
            </label>
						<div class="col-9">
							<div class="form-check form-check-inline mg-r-15">
								<label class="rdiobox">
                  <input
                    type="radio"
                    name="status"
                    value="1"
                    v-model="status"
                  >
                  <span>{{$t("express.启用")}}</span>
                </label>
							</div>
							<div class="form-check form-check-inline">
								<label class="rdiobox">
                  <input
                    type="radio"
                    name="status"
                    value="2"
                    v-model="status"
                  >
                  <span>{{$t("express.停用")}}</span>
                </label>
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" @click="save()">{{$t("express.保存")}}</button>
					<button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("express.取消")}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["open", "countrys", "info"],
		data() {
			return {
				loading: false,
				logistics: "", //物流名称
				ruleType: 1,
				everyFee: "",
				startWeight: "",
				startPrice: "",
				incWeight: "",
				incPrice: "",
				priceFree: "",
				startPrice3: "",
				incPrice3: "",
				volumetricWeight: "", //体积重系数
				status: 1 //1启用 2停用
			};
		},
		watch: {
			open() {
				//reset
				this.countrys.forEach(e => {
					e.active = false;
					e.sub.forEach(c => {
						c.checked = false;
					});
				});
				this.countrys[0].active = true;
				(this.loading = false),
				(this.logistics = ""),
				(this.ruleType = 1),
				(this.everyFee = ""),
				(this.startWeight = ""),
				(this.startPrice = ""),
				(this.incWeight = ""),
				(this.incPrice = ""),
				(this.priceFree = ""),
				(this.startPrice3 = ""),
				(this.incPrice3 = ""),
				(this.volumetricWeight = ""),
				(this.status = 1);
				if(this.info) {
					//修改赋值
					this.logistics = this.info.logistics;
					this.countrys.forEach(e => {
						e.sub.forEach(c => {
							if(this.info.countryCodeStr.indexOf(c.code2) > -1) {
								this.$set(c, "checked", true);
							}
						});
					});
					this.countrys.forEach(e => {
						e.active = false;
					});
					this.countrys.some(e => {
						if(this.checkedNum(e)) {
							e.active = true;
							return true;
						}
					});

					this.ruleType = this.info.ruleType;
					this.everyFee = this.info.ruleJson.everyFee;
					this.startWeight = this.info.ruleJson.startWeight;
					this.startPrice = this.ruleType != 3 ?
						this.info.ruleJson.startPrice :
						"";
					this.incWeight = this.info.ruleJson.incWeight;
					this.incPrice = this.ruleType != 3 ?
						this.info.ruleJson.incPrice :
						"";
					this.priceFree = this.info.priceFree;

					if(this.ruleType == 3) {
						this.startPrice3 = this.info.ruleJson.startPrice;
						this.incPrice3 = this.info.ruleJson.incPrice;
					}
					this.volumetricWeight = this.info.volumetricWeight;
					this.status = this.info.status;
				}
			}
		},
		methods: {
			saveSuccess() {
				this.$emit("saveSuccess");
			},
			save() {
				if(!this.logistics) {
					ShowTip(this.$t('express.请输入物流名称'), "danger");
					return;
				}
				let countryCode = [];
				this.countrys.forEach(e => {
					e.sub.forEach(sub => {
						if(sub.checked) {
							countryCode.push(sub.code2);
						}
					});
				});
				if(!countryCode.length) {
					ShowTip(this.$t('express.请选择支持国家'), "danger");
					return;
				}
				this.loading = true;
				let countryCodeStr = countryCode.join(",");
				let param = {
					logistics: this.logistics,
					volumetricWeight: this.volumetricWeight,
					countryCodeStr,
					ruleType: this.ruleType,
					everyFee: this.ruleType == 1 ? this.everyFee : "",
					startWeight: this.ruleType == 2 ? this.startWeight : "",
					startPrice: this.ruleType == 2 ? this.startPrice : "",
					incWeight: this.ruleType == 2 ? this.incWeight : "",
					incPrice: this.ruleType == 2 ? this.incPrice : "",
					priceFree: this.priceFree,
					status: this.status
				};
				if(this.ruleType == 3) {
					param.startPrice = this.startPrice3;
					param.incPrice = this.incPrice3;
				}
				if(this.info) {
					param.id = this.info.id
				}
				$.api_call("api.InterShipping.createUpdate", param, r => {
					this.loading = false;
					if(r.ErrorCode == "9999") {
						this.saveSuccess();
					} else {
						if(r.ErrorCode == "1002") {
							userFailure(this);
						} else {
							ShowTip(r.Message, "danger");
						}
					}
				});
			},
			checkedNum(item) {
				let num = 0;
				item.sub.forEach(e => {
					if(e.checked) {
						num++;
					}
				});
				return num;
			},
			checkedContinent(item) {
				//洲是否全选
				return item.sub.every(e => {
					return e.checked;
				});
			},
			selectAllCountry(event, item) {
				item.sub.forEach(e => {
					this.$set(e, "checked", event.target.checked);
				});
			},
			changeContinent(item) {
				this.countrys.forEach(c => {
					this.$set(c, "active", false);
				});
				this.$set(item, "active", true);
			}
		}
	};
</script>

<style lang="less" scoped>
	.continents-nav {
		>a {
			display: flex;
			align-items: center;
			border: 1px #ddd solid;
			border-bottom: none;
			padding: 5px 15px;
			min-width: 125px;
		}
		>a:last-child {
			border-bottom: 1px #ddd solid;
		}
		>a.active {
			background-color: #17a2b8;
			color: #fff;
			border-right-color: #17a2b8;
		}
	}
	
	.country-wrap {
		padding: 5px 0;
		flex: 1;
		height: 192px;
		border: 1px #ddd solid;
		border-left: none;
		overflow-y: auto;
		.country-list {
			list-style: none;
			display: none;
			flex-wrap: wrap;
			margin: 0;
			padding: 0 15px;
			font-size: 12px;
			li {
				margin-right: 10px;
				margin-bottom: 3px;
				padding: 3px;
				border: 1px #ddd solid;
				user-select: none;
			}
			li.active {
				background-color: #eee;
				color: #333;
			}
		}
		.country-list.active {
			display: flex;
		}
	}
</style>